var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({staticClass:"wb-icon svg",attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }